import _ from "lodash";
import * as Yup from "yup";
import FormSet from "./FormSet";
import {FormUtils} from "..";

import {
    SCHEMA_NAMES as SchemaNameSpecialPrizes
} from "./../../../modules/configurations/components/ConfigurationsPage/NewConfigurationPage/SpecialPrizesConfigurationSection/FormBuild/SpecialPrizesConfigurationSection.constants"
import "./FormSet.scss";

const generateValidation = subFormType => {
    return Yup.object().shape(
        subFormType.fields.reduce((accumulator, field) => {
            return {
                ...accumulator,
                [field.name]: field.validationSchema
                    ? FormUtils.generateYupValidatorFromSchema(
                        field.validationSchema
                    )
                    : field.validation
            };
        }, {})
    );
};

class FormSetWays extends FormSet {
    onChange = (index, value) => {
        const newSubFormValues = [...this.state.subFormsValues];
        const newSubForms = [...this.state.subForms];

        if (isPresetValid(value.values["preset"]) &&
            newSubFormValues[index].values.preset !== value.values["preset"]
        ) {
            const prizePreset = this.props.presets["presets"].find(
                preset => preset.id == value.values["preset"]
            );

            /*if (
                this.props.extraFields &&
                this.props.extraFields.hasOwnProperty("min_bet") &&
                prizePreset.settings.proportion_type == "normal"
            ) {
                if (
                    !newSubForms[index].fields
                        .find(objt => objt.name == "prizes")
                        .fieldOptions["subFormTypes"][0].fields.find(
                            obj => obj.name == "min_bet"
                        )
                ) {
                    newSubForms[index].fields
                        .find(objt => objt.name == "prizes")
                        .fieldOptions["subFormTypes"][0].fields.splice(
                            5,
                            0,
                            this.props.extraFields.min_bet
                        );
                }

                const maxBetIndex = newSubForms[index].fields
                    .find(objt => objt.name == "prizes")
                    .fieldOptions["subFormTypes"][0].fields.findIndex(
                        obj => obj.name == "max_bet"
                    );

                if (maxBetIndex > -1) {
                    newSubForms[index].fields
                        .find(objt => objt.name == "prizes")
                        .fieldOptions["subFormTypes"][0].fields.splice(
                            maxBetIndex,
                            1
                        );
                }
            }

            if (
                this.props.extraFields &&
                this.props.extraFields.hasOwnProperty("max_bet") &&
                prizePreset.settings.proportion_type == "proportional"
            ) {
                if (
                    !newSubForms[index].fields
                        .find(objt => objt.name == "prizes")
                        .fieldOptions["subFormTypes"][0].fields.find(
                            obj => obj.name == "max_bet"
                        )
                ) {
                    newSubForms[index].fields
                        .find(objt => objt.name == "prizes")
                        .fieldOptions["subFormTypes"][0].fields.splice(
                            5,
                            0,
                            this.props.extraFields.max_bet
                        );
                }

                const minBetIndex = newSubForms[index].fields
                    .find(objt => objt.name == "prizes")
                    .fieldOptions["subFormTypes"][0].fields.findIndex(
                        obj => obj.name == "min_bet"
                    );

                if (minBetIndex > -1) {
                    newSubForms[index].fields
                        .find(objt => objt.name == "prizes")
                        .fieldOptions["subFormTypes"][0].fields.splice(
                            minBetIndex,
                            1
                        );
                }
            }*/

            let coinsPreset = Array.isArray(prizePreset.settings.coin)
                ? prizePreset.settings.coin
                : prizePreset.settings.coin !== undefined
                    ? [prizePreset.settings.coin]
                    : [];

            Array.isArray(prizePreset["prizes"]) && prizePreset["prizes"].map(prize => {
                const progressivePrizeIndex = value.values.prizes.findIndex(
                    pz => {
                        return pz.prize_index == prize.level;
                    }
                );

                if (progressivePrizeIndex > -1) {
                    value.values.prizes[progressivePrizeIndex]["max_bet"] = 1;
                    value.values.prizes[progressivePrizeIndex]["min_bet"] = 1;
                    if (value.values.prizes[progressivePrizeIndex].hasOwnProperty("min_game_mode")) value.values.prizes[progressivePrizeIndex]["min_game_mode"] = 0;
                    if (value.values.prizes[progressivePrizeIndex].hasOwnProperty("max_proportional_total_bet")) value.values.prizes[progressivePrizeIndex]["max_proportional_total_bet"] = 1;
                    if (value.values.prizes[progressivePrizeIndex].hasOwnProperty("fractionated_jackpot_list")) delete value.values.prizes[progressivePrizeIndex]["fractionated_jackpot_list"];

                    const convertibleFields = [
                        "contribution",
                        "max_value",
                        "increment_sound_value",
                        "initial_value"
                    ];
                    const prizesField = newSubForms[0].fields.find(field => field.name === "prizes")
                    Object.keys(prize).map(key => {
                        if (key == 'fractionated_jackpot_list') {
                            let progressivePrize = _.cloneDeep(prize);
                            value.values.prizes[progressivePrizeIndex][key] = progressivePrize[key]
                            value.values.prizes[progressivePrizeIndex][key].map(list_v => {
                                Object.keys(list_v).map(v => {
                                    if (v !== 'bet') {
                                        list_v[v] = list_v[v] / 100
                                    }
                                })
                            })
                        } else if (
                            value.values.prizes[
                                progressivePrizeIndex
                                ].hasOwnProperty(key)
                        ) {
                            const field = prizesField['fieldOptions']['subFormTypes'][0].fields.find(field => field.name === key)
                            const fieldIsConvert = field && field.validationSchema.convert
                            value.values.prizes[progressivePrizeIndex][key] =
                                convertibleFields.includes(key) || fieldIsConvert
                                    ? prize[key] / 100
                                    : prize[key];
                        }
                    });

                    if (
                        value.values.prizes[
                            progressivePrizeIndex
                            ].hasOwnProperty("proportion_type")
                    ) {
                        value.values.prizes[progressivePrizeIndex][
                            "proportion_type"
                            ] = prizePreset.settings.proportion_type;
                    }

                    value.values.prizes[progressivePrizeIndex]["key"] =
                        prizePreset.id;
                } else if (value.values.type == "levels") {
                    const progressivePrizeIndex =
                        value.values.children[0].prizes.findIndex(pz => {
                            return pz.prize_index == prize.level;
                        });

                    if (progressivePrizeIndex > -1) {
                        const convertibleFields = [
                            "contribution",
                            "max_value",
                            "increment_sound_value",
                            "initial_value"
                        ];
                        const childrenField = newSubForms[0].fields.find(field => field.name === "children")
                        if (childrenField[0]) {
                            const prizesField = childrenField[0].fields.find(field => field.name === "prizes")
                            Object.keys(prize).map(key => {
                                if (
                                    value.values.children[0].prizes[
                                        progressivePrizeIndex
                                        ].hasOwnProperty(key)
                                ) {
                                    const field = prizesField['fieldOptions']['subFormTypes'][0].fields.find(field => field.name === key)
                                    const fieldIsConvert = field && field.validationSchema.convert
                                    value.values.children[0].prizes[
                                        progressivePrizeIndex
                                        ][key] = convertibleFields.includes(key) || fieldIsConvert
                                        ? prize[key] / 100
                                        : prize[key];
                                }
                            });
                        }
                        if (
                            value.values.children[0].prizes[
                                progressivePrizeIndex
                                ].hasOwnProperty("proportion_type")
                        ) {
                            value.values.children[0].prizes[
                                progressivePrizeIndex
                                ]["proportion_type"] =
                                prizePreset.settings.proportion_type;
                        }

                        if (value.values.prizes[progressivePrizeIndex]) {
                            value.values.prizes[progressivePrizeIndex]["key"] =
                                prizePreset.id;
                        }
                    }

                    /*const levelsPrizes = newSubForms[index].fields
                        .find(objt => objt.name == "children")
                        .fieldOptions["subFormTypes"][0].fields.find(
                            objt => objt.name == "prizes"
                        );

                    const childrenPrizes = value.values.children[0].prizes;
                    console.log(levelsPrizes, childrenPrizes);*/
                }

                if (
                    value.values.hasOwnProperty("coin") &&
                    prize.hasOwnProperty("coin")
                ) {
                    coinsPreset.push(prize.coin);
                }
            });

            if (value.values.hasOwnProperty("coin") && coinsPreset.length > 0) {
                value.values["coin"] = _.uniq(coinsPreset);
            }

            if (value.values.type === "fractionated" || value.values.type === "mr_champion" || value.values.type === "pig_boom") {
                let preset = _.cloneDeep(prizePreset["settings"])
                Object.keys(preset).map(key => {
                    if (key === "fractionated_jackpot_list") {
                        preset[key].map(fract => {
                            Object.keys(fract).map(f => {
                                if (f !== 'bet') {
                                    fract[f] = fract[f] / 100
                                }
                            })
                        })
                        value.values[key] = preset[key]
                    } else {
                        const field = newSubForms[index].fields.find(field => field.name === key)
                        const fieldIsConvert = field && field.validationSchema.convert
                        value.values[key] = fieldIsConvert
                            ? preset[key] / 100
                            : preset[key];
                    }
                })
                if (value.values.type === "mr_champion") {
                    //keys que não estão presentes em todos os presets criados mas estão presentes no schema, por isso mostra valor default
                    [SchemaNameSpecialPrizes.NOTICE_PERIOD, SchemaNameSpecialPrizes.COUNT_DOWN_PERIOD].map(key => {
                        const field = newSubForms[index].fields.find(field => field.name === key)
                        const fieldIsConvert = field && field.validationSchema.convert
                        if (field != undefined && preset[key] == undefined) {
                            value.values[key] = fieldIsConvert
                                ? field.validationSchema.default / 100
                                : field.validationSchema.default;
                        }
                    })
                }
            }
        }

        if (
            value.values.hasOwnProperty("preset") &&
            value.values["preset"] !== "" &&
            value.values["preset"] === 0 &&
            newSubFormValues[index].values.preset !== value.values["preset"]
        ) {
            value.values.prizes.map(prize => {
                prize.key = value.values["preset"];
                prize.initial_value = 0;
                prize.proportion_type = 'normal';
            })
        }

        newSubFormValues[index] = {...value};

        newSubForms.map(form => {
            const field = form.fields.find(field => field.name === "id")
            if (field) {
                field.validationSchema.unique = newSubFormValues.map(formValue => formValue.values.id)
                form.validation = generateValidation(form)
                newSubFormValues[index].isValid = newSubForms[index].validation.isValidSync(newSubFormValues[index].values);
            }
        })

        if (newSubFormValues[index].values.hasOwnProperty("prize_index")) {
            newSubFormValues[index].isValid = newSubForms[index].validation.isValidSync(newSubFormValues[index].values);
        }

        if (value.values.type === 'easylink' || value.values.type === 'luckytokenslink' || value.values.type === 'progressive_group') {
            const prizesField = newSubForms[index].fields.find(field => field.name === "prizes");
            if (prizesField) {
                const gameSpecificField = prizesField.fieldOptions['subFormTypes'][0].fields.find(field => field.name === 'game_specific_settings');
                if (gameSpecificField) {
                    const prizePreset = this.props.presets["presets"].find(preset => preset.id == value.values["preset"]);
                    if (!isPresetValid(value.values["preset"]) || !prizePreset.game_specific_settings.length) {
                        gameSpecificField.fieldOptions.placeholder = "";
                        gameSpecificField.fieldOptions.classNames = "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 visibility-hidden";

                    } else {
                        const gameInstances = getGameInstances(prizePreset.game_specific_settings, this.props.gameInstances);
                        gameSpecificField.fieldOptions.placeholder = `This preset has ${prizePreset.game_specific_settings.length} alternative settings for games ${gameInstances}`;
                        gameSpecificField.fieldOptions.classNames = "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 visibility-visible";
                    }
                }
            }
        }
        if (!_.isEqual(newSubFormValues, this.state.subFormsValues)) {
            this.setState(
                {
                    subFormsValues: newSubFormValues,
                    subForms: newSubForms
                },
                () => {
                    this.fireChange();
                }
            );
        }
    };
}

const isPresetValid = preset => preset && preset !== "" && preset !== 0;

const getGameInstances = (gameSpecificSettings, gameInstances) => {
    const games = gameSpecificSettings.flatMap(game => game.game_instances);
    const gameNames = gameInstances['results'].filter(game => games.includes(game.id)).map(game => game.game.name);
    return gameNames.join(', ');
}
export default FormSetWays;
